import { css, keyframes } from "@emotion/react";
import type { NumberPixel } from "../types";
import type { SpinnerProps } from "./Spinner.types";

const spin = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

export const sizeToPxMap = {
  xsmall: "16px",
  small: "24px",
  medium: "32px",
  large: "64px",
} satisfies Record<Required<SpinnerProps>["size"], NumberPixel>;

export const spinnerCSS = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: var(--spinner-size);
  height: var(--spinner-size);

  animation: ${spin} var(--spinner-speed) linear infinite;
`;
